import type { ReactNode } from "react";

import { labelFor, toneFor, type StatusKind, type Tone } from "../statusTone";

/**
 * A status, always as text on a tonal fill — colour reinforces the state, it
 * never carries it alone.
 *
 * Two forms, and the first is the one to use: give it the KIND of thing and its
 * raw status and the shared table decides both the tone and the wording. The
 * explicit-tone form exists for the handful of places that need bespoke copy
 * ("Payout on hold") for a status the API does not model.
 */
type ByStatus = {
  kind: StatusKind;
  status: string | null | undefined;
  /** Overrides the table's label. The tone still comes from the table. */
  children?: ReactNode;
  tone?: never;
};

type ByTone = {
  tone: Tone;
  children: ReactNode;
  kind?: never;
  status?: never;
};

export type StatusPillProps = ByStatus | ByTone;

export function StatusPill(props: StatusPillProps) {
  if (props.kind !== undefined) {
    const tone = toneFor(props.kind, props.status);
    return (
      <span className={`status-pill status-pill--${tone}`}>
        {props.children ?? labelFor(props.kind, props.status)}
      </span>
    );
  }
  return <span className={`status-pill status-pill--${props.tone}`}>{props.children}</span>;
}
